(function () {
  'use strict';

  const container = document.getElementById('clock-designer');
  if (!container) return;

  const apiBase = container.dataset.api || '';
  const productHandle = container.dataset.productHandle || '';

  // Each product listing's Product Options app renders its own question set
  // with its own auto-generated field IDs — these are NOT shared across
  // products, even when the questions look similar. Keyed by product.handle.
  var FIELD_MAPS = {
    'logo-clocks-design-your-own': {
      // Re-checked against the live page 2026-10-07. The option set had been
      // edited in the Product Options admin since these ids were written, and
      // four of them no longer exist on the page. Only one of those four cost
      // anything: logo_position pointed at po_checkbox1391060, a preset
      // picker that has been replaced by a free-text question
      // (po_text_area1475748, "Opt: Tell where you want the logo and how
      // large."). A customer typing "top of the clock between the 10 and 2"
      // had that answer silently discarded and the request sent as "Let AI
      // decide" instead.
      //
      // clock_style, inspiration_file_upload and extra_notes are null because
      // this listing no longer asks those questions. They previously held
      // po_checkbox1391043, po_file_upload1391046 and po_text_area1389906 —
      // see git history, which is the right place for that record.
      //
      // Nulling them is not cosmetic. missingMappedFields reports any mapped
      // id that is not on the page, and an id for a deliberately removed
      // question is indistinguishable from a stale one. Left as ids, all three
      // would be flagged on every single order, and a signal that always fires
      // is a signal nobody reads. null states "not asked"; an id states
      // "expected to be here".
      clock_style: null,
      background_description: 'po_text_area1391058',
      logo_file_upload: 'po_file_upload1389907',
      logo_position: 'po_text_area1475748',
      number_style: 'po_text_area1391045',
      additional_text: 'po_text_area1391061',
      inspiration_file_upload: null,
      extra_notes: null,
      art_style: null,
      // Was null, but this listing does have a Hand Color dropdown
      // (po_dropdown1417729). It happens to work anyway: with hand_color
      // unmapped, getHandColor falls back to reading the unscoped
      // #bss-po-dropdown-selected-option element, and this page has only one
      // dropdown for it to match. Mapped explicitly so it no longer depends
      // on that coincidence.
      hand_color: 'po_dropdown1417729',
    },
    'you-design-ai-logo-clocks-copy': {
      // Styles/Theme/Art Style render as DROPDOWN widgets on this listing
      // (option_type 3 = "po_dropdown"), unlike the original product's
      // equivalent field which is an actual CHECKBOX widget (option_type 2
      // = "po_checkbox") — confirmed from the live BSS app bundle's own
      // type-to-prefix map, not assumed by analogy.
      clock_style: 'po_dropdown1410758',
      background_description: 'po_dropdown1410762',
      logo_file_upload: 'po_file_upload1410756',
      logo_position: 'po_text_area1410761',
      number_style: 'po_text_area1410757',
      additional_text: 'po_text_area1410760',
      inspiration_file_upload: null,
      extra_notes: 'po_text_area1410755',
      art_style: 'po_dropdown1410763',
      hand_color: 'po_dropdown1417737',
    },
    'ai-you-design-ai-logo-clocks-copy': {
      // Contest/giveaway listing — a stripped-down option set with only 5
      // fields (no Clock Style, Logo Position, Inspiration Upload, Extra
      // Notes, or Art Style questions). IDs confirmed from the live BSS
      // widget's rendered field names, not assumed by analogy.
      clock_style: null,
      background_description: 'po_text_area1469410',
      logo_file_upload: 'po_file_upload1469408',
      logo_position: null,
      number_style: 'po_text_area1469409',
      additional_text: 'po_text_area1469412',
      inspiration_file_upload: null,
      extra_notes: null,
      art_style: null,
      hand_color: 'po_dropdown1469413',
    },
  };

  // A listing with no entry above gets an EMPTY map, not another listing's
  // ids. Falling back to logo-clocks-design-your-own's map meant every
  // question on a brand-new listing looked "mapped, but missing from this
  // page" — so missingMappedFields reported a SETUP PROBLEM and stamped
  // _Clock Setup Problem onto every order from it. An unconfigured listing
  // is not a misconfigured one, and a warning that fires on every order of a
  // working listing is a warning nobody reads.
  //
  // Nothing important is lost by having no entry: the logo upload is found
  // by its question's label, the hand colour by the value showing in the
  // dropdown, and every other answer reaches the AI through
  // collectUnmappedAnswers. A FIELD_MAPS entry only adds the per-field
  // handling on top of that.
  function fieldsForThisListing() {
    return FIELD_MAPS[productHandle] || {};
  }

  // Diagnostic for setting up a listing: load the product page with
  // ?clockdebug=1 and the console shows every Optis question found, the
  // label read for it, and which payload field claimed it. This is the check
  // to run after duplicating a listing — the alternative is discovering a
  // mismapped question from a customer's order.
  function reportQuestions() {
    if (window.location.search.indexOf('clockdebug=1') === -1) return;
    var lib = window.ClockFieldMatcher;
    if (!lib) {
      console.warn('[clock-designer] question report unavailable: matcher asset did not load');
      return;
    }
    var questions = lib.describeQuestions(document);
    console.log('[clock-designer] question report for ' + (productHandle || '(unknown handle)'));
    if (!questions.length) {
      console.warn('[clock-designer] no Optis questions found on this page at all');
      return;
    }
    for (var i = 0; i < questions.length; i++) {
      var q = questions[i];
      console.log(
        '  ' + q.name + '  [' + q.type + ']  label: ' +
        (q.label ? '"' + q.label + '"' : '(none resolved)')
      );
    }
  }

  reportQuestions();

  // Move into sidebar above ShopPay installments
  (function reposition() {
    var anchor = document.querySelector(
      'shopify-payment-terms, .shopify-payment-terms, [data-shopify-installments], .product__payment-terms'
    );
    if (anchor) {
      anchor.parentNode.insertBefore(container, anchor);
    } else {
      // Fallback: insert at top of product meta/form sidebar
      var sidebar = document.querySelector(
        '.product-single__meta, .product__info-wrapper, .product-form__info-container, [data-product-form]'
      );
      if (sidebar) sidebar.insertBefore(container, sidebar.firstChild);
    }
  })();

  let clockLogoBase64 = '';
  // Photographs two onward. A memorial clock is three pictures of a person,
  // and the upload box takes them all — this used to read files[0] and the
  // rest were dropped here in the browser, before anything was sent.
  let clockExtraPhotos = [];
  let clockLogoMimeType = 'image/png';
  let productionImageId = null;
  let previewImageUrl = null;
  let logoProductionUrl = null;

  // Shopify prints every line item property, cart attribute and order note on
  // the customer's cart, checkout and confirmation email UNLESS the name
  // starts with an underscore — underscore-prefixed ones still travel in the
  // order payload that ShipStation reads, but are never shown to the
  // customer. The print file is the handless, ringless artwork, so it goes
  // hidden; the preview is the design the customer approved, and is the only
  // clock image link they ever see.
  const PRINT_FILE_PROP = '_Production Clock URL';
  const PREVIEW_PROP = 'Your Design';
  const LOGO_PROP = 'Logo URL';
  const SETUP_PROBLEM_PROP = '_Clock Setup Problem';

  // Which mapped questions are not on the page at all.
  //
  // This is the distinction the designer could not previously draw. Reading a
  // field is `optis[id] || ''`, so a question that has been replaced (new id)
  // and a question the customer left blank both produce '' — identical, and
  // indistinguishable. A stale id therefore read as "the customer didn't
  // answer", and their answer was discarded with nothing reporting it.
  //
  // That is not hypothetical: logo_position pointed at po_checkbox1391060
  // long after that preset picker had been replaced by a free-text question,
  // so every customer who typed where they wanted their logo had it thrown
  // away and the request sent as "Let AI decide" instead.
  //
  // Presence is tested against the DOM rather than against the scraped
  // values, because getOptisValues only records a CHECKED checkbox — an
  // unchecked one is present but absent from that object, which would look
  // identical to a missing question.
  var _missingFields = null;
  // What the upload slot on this product holds: 'photo' or 'logo'.
  //
  // A product tag, for the same reason the designer itself is switched on by
  // one. The handle list that used to gate the designer failed exactly the
  // way a hardcoded list fails — duplicating and renaming listings moved the
  // handles, two stopped existing, the new duplicate was never listed, and
  // every one of them silently rendered nothing. Keying the photo/logo
  // choice to handles would reproduce that: rename the car listing and it
  // quietly goes back to being told it holds a logo.
  //
  // A tag travels with the product through duplication and renaming. An
  // untagged product sends nothing, and the backend treats nothing as a logo
  // listing — which is how every upload was handled before any of this
  // existed, so an untagged listing behaves exactly as it always did.
  function uploadKind() {
    var root = document.getElementById('clock-designer');
    var tags = ((root && root.getAttribute('data-product-tags')) || '').toLowerCase();
    if (tags.indexOf('clock-photo') !== -1) return 'photo';
    if (tags.indexOf('clock-logo') !== -1) return 'logo';
    return '';
  }

  function missingMappedFields() {
    if (_missingFields) return _missingFields;
    var fields = fieldsForThisListing();
    var missing = [];
    for (var name in fields) {
      if (!Object.prototype.hasOwnProperty.call(fields, name)) continue;
      // null means this listing genuinely does not ask the question. Not a fault.
      if (!fields[name]) continue;
      if (!document.querySelector('[name="' + fields[name] + '"]')) {
        missing.push(name + '=' + fields[name]);
      }
    }
    _missingFields = missing;
    if (missing.length) {
      console.warn(
        '[clock-designer] SETUP PROBLEM: ' + missing.length + ' mapped question(s) are not on ' +
        'this page, so any answer the customer gives them is being discarded: ' +
        missing.join(', ') + '. The Product Options question set has changed since ' +
        'FIELD_MAPS was written — re-check the ids. Load this page with ?clockdebug=1 ' +
        'for the questions that ARE present.'
      );
    }
    return missing;
  }

  // Single source of truth for what gets attached to the cart. All six
  // injection methods below go through this, so a property can't end up
  // named one thing on one path and something else on another.
  function clockCartProperties() {
    const props = {};
    if (productionImageId) props[PRINT_FILE_PROP] = productionImageId;
    if (previewImageUrl) props[PREVIEW_PROP] = previewImageUrl;
    if (logoProductionUrl) props[LOGO_PROP] = logoProductionUrl;
    // Rides the order so a stale mapping surfaces where it will actually be
    // seen. A console warning is invisible to anyone not looking for it, and
    // there is no alerting in the backend — the order is the one place the
    // shop owner reliably looks, so the first order after a question edit
    // reports the problem instead of it going unnoticed for months.
    // Underscore-prefixed, so the customer never sees it.
    var missing = missingMappedFields();
    if (missing.length) props[SETUP_PROBLEM_PROP] = 'Questions not found: ' + missing.join(', ');
    return props;
  }

  let clockHistory = [];
  let currentHistoryIndex = -1;

  const LOADING_MESSAGES = [
    'Understanding your style…',
    'Crafting your clock face…',
    'Choosing the perfect colors…',
    'Placing the hour markers…',
    'Adding the finishing touches…',
    'Almost ready…',
  ];
  let loadingMsgInterval = null;
  let loadingSlowTimer = null;
  let loadingMsgIndex = 0;

  function startLoadingMessages() {
    const msgEl = document.getElementById('clock-loading-msg');
    if (!msgEl) return;
    loadingMsgIndex = 0;
    msgEl.style.opacity = '1';
    msgEl.textContent = LOADING_MESSAGES[0];
    loadingMsgInterval = setInterval(function () {
      msgEl.style.opacity = '0';
      setTimeout(function () {
        loadingMsgIndex = (loadingMsgIndex + 1) % LOADING_MESSAGES.length;
        msgEl.textContent = LOADING_MESSAGES[loadingMsgIndex];
        msgEl.style.opacity = '1';
      }, 400);
    }, 3000);
    // Past this point the cheerful rotation is actively misleading: it looks
    // identical at 20 seconds and at two minutes, so a customer on a slow
    // design has no way to tell progress from a hang, and closing the tab is
    // the reasonable thing to do. One in ten generations runs past 115s.
    loadingSlowTimer = setTimeout(function () {
      if (loadingMsgInterval) { clearInterval(loadingMsgInterval); loadingMsgInterval = null; }
      msgEl.style.opacity = '1';
      msgEl.textContent = 'Still working — a detailed design can take a couple of minutes. Please keep this page open.';
    }, 45000);
  }

  function stopLoadingMessages() {
    if (loadingMsgInterval) { clearInterval(loadingMsgInterval); loadingMsgInterval = null; }
    if (loadingSlowTimer) { clearTimeout(loadingSlowTimer); loadingSlowTimer = null; }
  }

  // ── Method 1: intercept fetch /cart/add ──────────────────────────────────
  const _origFetch = window.fetch;
  window.fetch = function (resource, init) {
    const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    if (productionImageId && url.indexOf('/cart/add') !== -1) {
      try {
        const props = clockCartProperties();
        if (init && typeof init.body === 'string') {
          const parsed = JSON.parse(init.body);
          const inject = function (item) {
            item.properties = Object.assign(item.properties || {}, props);
          };
          if (Array.isArray(parsed.items)) parsed.items.forEach(inject);
          else inject(parsed);
          init = Object.assign({}, init, { body: JSON.stringify(parsed) });
        } else if (init && init.body instanceof FormData) {
          Object.keys(props).forEach(function (name) {
            init.body.append('properties[' + name + ']', props[name]);
          });
        }
      } catch (e) {}
    }
    return _origFetch.call(this, resource, init);
  };

  // ── Method 2: intercept XHR /cart/add ────────────────────────────────────
  const _origXHROpen = XMLHttpRequest.prototype.open;
  const _origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._clockUrl = url || '';
    return _origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (data) {
    if (productionImageId && this._clockUrl && this._clockUrl.indexOf('/cart/add') !== -1) {
      try {
        const parsed = JSON.parse(data);
        const props = clockCartProperties();
        const inject = function (item) {
          item.properties = Object.assign(item.properties || {}, props);
        };
        if (Array.isArray(parsed.items)) parsed.items.forEach(inject);
        else inject(parsed);
        data = JSON.stringify(parsed);
      } catch (e) {}
    }
    return _origXHRSend.call(this, data);
  };

  let clockPreviewUrl = '';

  function saveProductionUrl(url, previewUrl) {
    if (previewUrl) clockPreviewUrl = previewUrl;
    productionImageId = url;
    if (previewUrl) previewImageUrl = previewUrl;
    var props = clockCartProperties();

    // Method 3: cart note + cart attributes.
    // The note is shown to the customer at checkout, so it carries the
    // preview link, never the print file.
    _origFetch.call(window, '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        note: previewImageUrl ? 'Your Design: ' + previewImageUrl : '',
        attributes: props,
      }),
    }).catch(function () {});

    // Method 4: hidden input on every form that could add to cart
    document.querySelectorAll('form[action*="/cart/add"], form[action="/cart/add"]').forEach(function (form) {
      Object.keys(props).forEach(function (name) {
        var selector = '[name="properties[' + name + ']"]';
        var input = form.querySelector(selector);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          form.appendChild(input);
        }
        input.value = props[name];
      });
    });

    // Method 5: localStorage so it's always findable
    try {
      localStorage.setItem('clock_production_url', url);
      if (previewImageUrl) localStorage.setItem('clock_preview_url', previewImageUrl);
      if (logoProductionUrl) localStorage.setItem('clock_logo_url', logoProductionUrl);
    } catch (e) {}

    // Method 6: start polling — will inject once the clock item appears in cart
    startCartPropertyPolling(url);
  }

  function renderHistory() {
    if (!historyEl || !thumbsEl) return;
    if (clockHistory.length <= 1) { historyEl.style.display = 'none'; return; }
    historyEl.style.display = 'block';
    thumbsEl.innerHTML = '';
    clockHistory.forEach(function (entry, i) {
      var wrap = document.createElement('div');
      wrap.title = i === 0 ? 'Original' : 'Version ' + (i + 1);
      wrap.style.cssText = 'flex-shrink:0; cursor:pointer; border:3px solid ' +
        (i === currentHistoryIndex ? '#2EC4D6' : '#ddd') +
        '; border-radius:4px; overflow:hidden; transition:border-color 0.15s;';
      var img = document.createElement('img');
      img.src = 'data:image/png;base64,' + entry.image_base64;
      img.style.cssText = 'width:64px; height:64px; object-fit:cover; display:block;';
      wrap.appendChild(img);
      wrap.addEventListener('click', function () { restoreVersion(i); });
      thumbsEl.appendChild(wrap);
    });
  }

  function restoreVersion(index) {
    var entry = clockHistory[index];
    if (!entry) return;
    currentHistoryIndex = index;
    previewImg.src = 'data:image/png;base64,' + entry.image_base64;
    window._clockRawImageBase64 = entry.raw_image_base64;
    window._clockRingGeometry = entry.ring_geometry || null;
    if (entry.production_url) saveProductionUrl(entry.production_url, entry.preview_url);
    renderHistory();
  }

  // Method 6: poll the cart every 2 s for up to 60 s and inject once the clock
  // item appears.  This is BSS-Product-Options-safe because it does not rely on
  // intercepting BSS's own fetch reference — it just reads and patches cart state.
  function startCartPropertyPolling(url) {
    var attempts = 0;
    var maxAttempts = 30;
    function poll() {
      if (!productionImageId || attempts >= maxAttempts) return;
      attempts++;
      _origFetch.call(window, '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var clocks = items.filter(function (i) {
            return i.handle && i.handle.indexOf('logo-clock') !== -1;
          });
          if (!clocks.length) { setTimeout(poll, 2000); return; }
          var item;
          if (clocks.length === 1) {
            // The ordinary case, including a customer who regenerates after
            // adding to cart: there is only one clock, so it is this design's.
            item = clocks[0];
          } else {
            // More than one clock in the cart. This poll has no way to tell
            // which line item belongs to the design currently on screen, and
            // taking the first match stamped THIS artwork onto a clock the
            // customer had already designed differently — that clock would be
            // printed with the wrong design. The only line item we can safely
            // claim is one that carries no print file yet.
            item = clocks.find(function (i) {
              return !(i.properties && i.properties[PRINT_FILE_PROP]);
            });
            if (!item) return;
          }
          if (item.properties && item.properties[PRINT_FILE_PROP] === url) return;
          var props = Object.assign({}, item.properties || {}, clockCartProperties());
          // Clear the pre-rename property if an older cart item still carries
          // it — leaving it behind would show the customer the print file.
          if (props['Production Clock URL']) props['Production Clock URL'] = '';
          _origFetch.call(window, '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, properties: props }),
          }).catch(function () { setTimeout(poll, 2000); });
        })
        .catch(function () { setTimeout(poll, 2000); });
    }
    setTimeout(poll, 1500);
  }

  function injectIntoCartItem() {
    if (productionImageId) startCartPropertyPolling(productionImageId);
  }

  // The upload field's id differs per listing like every other question.
  // This used to come from FIELD_MAPS, hardcoded to the original product's
  // id, which meant the two later listings never populated clockLogoBase64:
  // a file input's own .value is only ever "C:\fakepath\<name>", so logo_url
  // carried that instead of anything fetchable, resolve_logo_bytes came back
  // empty, and the customer's logo was silently dropped from a clock they
  // had uploaded it for. Now found the same way as everything else that
  // used to need a hardcoded id — see findFileUploadFields — so a brand-new
  // listing's logo upload works with no FIELD_MAPS entry at all.
  /** Every file in an upload box, as base64, in the order they were added. */
  function readAllFiles(files) {
    return Promise.all(Array.prototype.map.call(files, function (f) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (e) { resolve(e.target.result.split(',')[1]); };
        // One unreadable file must not lose the others, so it resolves empty
        // and is filtered out rather than rejecting the whole batch.
        reader.onerror = function () { resolve(''); };
        reader.readAsDataURL(f);
      });
    })).then(function (list) { return list.filter(Boolean); });
  }

  function attachLogoListener() {
    var logoFieldName = findFileUploadFields().logo;
    if (!logoFieldName) return;
    const fileInput = document.querySelector('[name="' + logoFieldName + '"]');
    if (!fileInput || fileInput._clockListenerAdded) return;
    fileInput._clockListenerAdded = true;
    fileInput.addEventListener('change', function () {
      const files = this.files;
      if (!files || !files.length) { clockLogoBase64 = ''; clockExtraPhotos = []; return; }
      clockLogoMimeType = files[0].type || 'image/png';
      readAllFiles(files).then(function (all) {
        clockLogoBase64 = all[0] || '';
        clockExtraPhotos = all.slice(1);
      });
    });
  }

  attachLogoListener();
  setTimeout(attachLogoListener, 1000);
  setTimeout(attachLogoListener, 3000);

  /** Read whatever logo is in the upload field right now.
   *
   * The change listener above is an optimisation, not the source of truth,
   * and on its own it is not reliable: it binds to the element present when
   * it runs, at 0s, 1s and 3s after load. The options app renders its
   * questions by AJAX and re-renders the upload field once a file has been
   * taken — so the element carrying the customer's file can be a different
   * one from the element being listened to, the change event fires where
   * nothing is listening, and the logo is silently dropped from a clock
   * they uploaded it for. Reported from a real listing, with the file
   * plainly visible on the page and absent from the design.
   *
   * Reading at submit time has no such dependence on when anything
   * rendered: a file input hands over its .files whenever it is asked.
   */
  function readLogoNow() {
    return new Promise(function (resolve) {
      var name = findFileUploadFields().logo;
      if (!name) return resolve(false);
      var input = document.querySelector('[name="' + name + '"]');
      var files = input && input.files;
      if (!files || !files.length) return resolve(false);
      clockLogoMimeType = files[0].type || 'image/png';
      readAllFiles(files).then(function (all) {
        clockLogoBase64 = all[0] || '';
        clockExtraPhotos = all.slice(1);
        resolve(!!clockLogoBase64);
      });
    });
  }

  // Hand overlay — instant client-side preview
  var _handImages = {};
  var _handApplyTimer = null;

  function preloadHandImages() {
    ['black', 'gold', 'silver', 'white'].forEach(function (color) {
      _origFetch.call(window, apiBase + '/hand-image/' + color)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var img = new Image();
          img.src = 'data:' + d.mime_type + ';base64,' + d.base64;
          _handImages[color] = img;
        })
        .catch(function () {});
    });
  }

  // Edge banding ring — must match the backend's add_edge_ring exactly:
  // slightly off-white for white hands (a pure white ring would vanish
  // against the clock image's own white exterior background), black for
  // every other hand color (including none selected yet), always drawn
  // regardless of hand color.
    function drawRing(ctx, color) {
    var g = window._clockRingGeometry;
    if (!g || !g.radius) return;
    var light = color === 'white';

    if (light) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(g.cx, g.cy, g.radius, 0, Math.PI * 2);
      ctx.clip();
      ctx.beginPath();
      ctx.arc(g.cx, g.cy, g.radius - g.thickness * 0.5, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(60,60,60,0.78)';
      ctx.lineWidth = Math.max(3, g.thickness * 1.3);
      ctx.filter = 'blur(' + Math.max(2, Math.round(g.thickness * 0.65)) + 'px)';
      ctx.stroke();
      ctx.restore();
    }

    ctx.beginPath();
    ctx.arc(g.cx, g.cy, g.radius, 0, Math.PI * 2);
    ctx.strokeStyle = light ? '#e6e6e6' : '#000000';
    ctx.lineWidth = g.thickness;
    ctx.stroke();
  }

  function applyHandPreview(color) {
    var base64 = window._clockRawImageBase64;
    if (!base64 || !previewImg) return;
    var canvas = document.createElement('canvas');
    canvas.width = 1024; canvas.height = 1024;
    var ctx = canvas.getContext('2d');
    var baseImg = new Image();
    baseImg.onload = function () {
      ctx.drawImage(baseImg, 0, 0, 1024, 1024);
      var handImg = color ? _handImages[color] : null;
      if (handImg) {
        var size = Math.round(1024 * 0.9);
        var offset = Math.round((1024 - size) / 2);
        ctx.drawImage(handImg, offset, offset, size, size);
      }
      drawRing(ctx, color);
      previewImg.src = canvas.toDataURL('image/png');
    };
    baseImg.src = 'data:image/png;base64,' + base64;
  }

  function applyHandProduction(color) {
    var base64 = window._clockRawImageBase64;
    if (!base64) return;
    clearTimeout(_handApplyTimer);
    _handApplyTimer = setTimeout(function () {
      _origFetch.call(window, apiBase + '/apply-hands', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_base64: base64, hand_color: color || '' }),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.production_image_url) saveProductionUrl(d.production_image_url, d.preview_image_url);
          // Swap the instant canvas-drawn preview (approximate — a different
          // rendering engine than the backend's PIL-drawn ring) for the
          // authoritative server-rendered image, which uses the exact same
          // add_edge_ring code path as the initial generate/edit result.
          // Skip if the hand color has changed again since this request was
          // sent, so a slow/stale response can't overwrite a newer preview.
          if (d.image_base64 && previewImg && window._clockHandColor === color) {
            previewImg.src = 'data:image/png;base64,' + d.image_base64;
          }
        })
        .catch(function () {});
    }, 500);
  }

  function onHandColorChanged() {
    var color = getHandColor();
    window._clockHandColor = color;
    applyHandPreview(color);
    applyHandProduction(color);
  }

  function watchHandColorDropdown() {
    var lastColor = null;
    setInterval(function () {
      var color = getHandColor();
      if (color !== lastColor) {
        lastColor = color;
        window._clockHandColor = color;
        if (window._clockRawImageBase64) {
          applyHandPreview(color);
          applyHandProduction(color);
        }
      }
    }, 300);
  }

  preloadHandImages();
  watchHandColorDropdown();

  const btn = document.getElementById('clock-generate-btn');
  const loadingEl = document.getElementById('clock-loading');
  const errorEl = document.getElementById('clock-error');
  const errorMsg = document.getElementById('clock-error-msg');
  const retryBtn = document.getElementById('clock-retry-btn');
  const resultEl = document.getElementById('clock-result');
  const previewImg = document.getElementById('clock-preview-img');
  const inlineAtc = document.getElementById('clock-inline-atc');
  const regenHint = document.getElementById('clock-regen-hint');
  const historyEl = document.getElementById('clock-history');
  const thumbsEl = document.getElementById('clock-history-thumbs');

  // Lightbox
  const lightbox = document.getElementById('clock-lightbox');
  const lightboxImg = document.getElementById('clock-lightbox-img');
  const lightboxClose = document.getElementById('clock-lightbox-close');
  if (previewImg && lightbox && lightboxImg) {
    previewImg.addEventListener('click', function () {
      lightboxImg.src = previewImg.src;
      lightbox.style.display = 'flex';
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lightboxClose) {
        lightbox.style.display = 'none';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') lightbox.style.display = 'none';
    });
  }

  const addToCart = document.querySelector('[name="add"], .product-form__submit, button[data-add-to-cart]');
  if (addToCart) {
    addToCart.style.display = 'none';
    addToCart.addEventListener('click', injectIntoCartItem);
  }

  function showLoading() {
    loadingEl.style.display = 'block';
    errorEl.style.display = 'none';
    resultEl.style.display = 'none';
    btn.disabled = true;
    btn.textContent = clockHistory.length ? 'Regenerating…' : 'Generating…';
    startLoadingMessages();
  }

  function showError(msg) {
    stopLoadingMessages();
    loadingEl.style.display = 'none';
    errorEl.style.display = 'block';
    errorMsg.textContent = msg;
    btn.disabled = false;
    btn.style.display = '';
    btn.textContent = clockHistory.length ? 'Regenerate' : 'Generate My Clock';
  }

  function ringGeometryFromResponse(data) {
    if (!data.ring_radius) return null;
    return { cx: data.ring_cx, cy: data.ring_cy, radius: data.ring_radius, thickness: data.ring_thickness };
  }

  function showResult(base64Image, prodUrl, rawBase64, logoUrl, ringGeometry, previewUrl) {
    if (logoUrl) logoProductionUrl = logoUrl;
    stopLoadingMessages();
    loadingEl.style.display = 'none';
    errorEl.style.display = 'none';
    resultEl.style.display = 'block';
    previewImg.src = 'data:image/png;base64,' + base64Image;
        window._clockRawImageBase64 = rawBase64 || null;
    window._clockRingGeometry = ringGeometry || null;

    clockHistory.push({
      image_base64: base64Image,
      raw_image_base64: rawBase64 || null,
      production_url: prodUrl || '',
      preview_url: previewUrl || '',
      ring_geometry: ringGeometry || null,
    });
    currentHistoryIndex = clockHistory.length - 1;
    renderHistory();

    if (prodUrl) saveProductionUrl(prodUrl, previewUrl);
    // The button stays put and becomes "Regenerate", so a customer who does
    // not like their clock can roll again from the same answers.
    //
    // It was hidden here for a while, on the reasoning that every press is a
    // full Claude + image + QC run billed to the shop and that a customer
    // wanting something different should use the edit box instead. That edit
    // box has since been removed, which left no way at all to get a
    // different design — the cost argument was sound, but it depended on an
    // alternative that no longer exists.
    //
    // Previous versions are kept in the history strip above the preview, so
    // rolling again never destroys a design the customer liked.
    //
    // Left enabled rather than disabled on purpose: the error panel's Try
    // Again button works by calling btn.click(), and a disabled button
    // swallows that click, stranding a customer whose generation failed.
    btn.disabled = false;
    btn.style.display = '';
    btn.textContent = 'Regenerate';
    if (regenHint) regenHint.style.display = 'block';
    if (addToCart) addToCart.style.display = '';
    if (inlineAtc) inlineAtc.style.display = 'block';
  }

  function getOptisValues() {
    const values = {};
    // Scoped to actual form controls (select/input/textarea) — BSS's DROPDOWN
    // widget stamps the same name="po_dropdown<id>" attribute onto every
    // <option> child, not just the <select> itself. A bare
    // '[name^="po_"]' selector walks into those <option> elements too, and
    // since forEach assigns in DOM order, the LAST option in the list always
    // overwrote the select's real (correctly-synced) value — silently
    // replacing whatever the customer picked with the dropdown's last entry.
    document.querySelectorAll('select[name^="po_"], input[name^="po_"], textarea[name^="po_"]').forEach(function (input) {
      const key = input.name;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) values[key] = input.value;
      } else {
        values[key] = input.value;
      }
    });
    return values;
  }

  // BSS's dropdown widget is a hidden native <select> behind a custom-styled
  // overlay div. The <select>'s own .value cannot be trusted: when nothing
  // has been actively chosen, BSS's template defaults it to the LAST real
  // <option> in the list instead of the placeholder — even though the
  // visible overlay still correctly displays "-- Please select --" to the
  // customer. Reading .value directly silently sends the dropdown's last
  // entry as if the customer had chosen it. The overlay text is the only
  // reliable source of truth, so read that instead, scoped to this specific
  // field's wrapper (the overlay's id is reused, unscoped, across every
  // dropdown on the page).
  function getDropdownVisibleText(fieldId) {
    var wrapper = document.querySelector('#bss-po_dropdown' + fieldId);
    var el = wrapper && wrapper.querySelector('#bss-po-dropdown-selected-option');
    if (!el) return '';
    var text = Array.from(el.childNodes)
      .filter(function (n) { return n.nodeType === Node.TEXT_NODE; })
      .map(function (n) { return n.textContent.trim(); })
      .join('').trim();
    if (!text || /please select/i.test(text)) return '';
    return text;
  }

  // Resolve a mapped field name to its real value. Dropdown fields
  // (name starting "po_dropdown") always go through the visible-text
  // reader above; everything else (text areas, checkboxes) comes from the
  // generic DOM scan in getOptisValues, whose values ARE trustworthy.
  function fieldValue(optis, fieldName) {
    if (!fieldName) return '';
    if (fieldName.indexOf('po_dropdown') === 0) {
      return getDropdownVisibleText(fieldName.slice('po_dropdown'.length));
    }
    return optis[fieldName] || '';
  }

  // Which Optis field ids this listing's FIELD_MAPS actually names — a
  // lookup set, so collectUnmappedAnswers() can tell "a question this code
  // already handles" apart from "a question it has never heard of".
  function mappedFieldIds() {
    var fields = fieldsForThisListing();
    var ids = {};
    for (var key in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, key) && fields[key]) ids[fields[key]] = true;
    }
    return ids;
  }

  // Scans every dropdown's CURRENT selection for one of the four hand colors
  // this app has overlay artwork for, and returns both the match and which
  // field id it came from — the id matters to collectUnmappedAnswers, so
  // it does not also report the very same dropdown as an "extra" answer.
  //
  // Value-based, not id-based, deliberately: it does not depend on knowing
  // which field id is "hand color" for a given listing at all, so it keeps
  // working across listing duplicates, a question's id changing after a
  // widget-type edit, or a brand-new listing whose FIELD_MAPS entry has not
  // been written yet — the only thing it depends on is the customer
  // having picked Black/Gold/Silver/White from SOME dropdown, which is
  // reliable because those are the only four values that widget can ever
  // show.
  //
  // Replaces an earlier fallback that read a single, non-unique element id
  // (#bss-po-dropdown-selected-option) via document.getElementById, which
  // only ever worked by coincidence on a listing with exactly one dropdown
  // in total — getElementById returns the FIRST match in the whole
  // document, so on a listing with several dropdowns (clock style, theme,
  // art style, hand color) it would silently read whichever one happened to
  // render first on the page, not necessarily hand color.
  function findHandColorField() {
    var wrappers = document.querySelectorAll('[id^="bss-po_dropdown"]');
    for (var i = 0; i < wrappers.length; i++) {
      var selected = wrappers[i].querySelector('.po-dropdown-selected-option');
      if (!selected) continue;
      var text = Array.from(selected.childNodes)
        .filter(function (n) { return n.nodeType === Node.TEXT_NODE; })
        .map(function (n) { return n.textContent.trim(); })
        .join('')
        .toLowerCase();
      var match = ['black', 'gold', 'silver', 'white'].find(function (c) { return text.includes(c); });
      if (match) return { name: wrappers[i].id.slice('bss-'.length), color: match };
    }
    return { name: '', color: '' };
  }

  function getHandColor() {
    return findHandColorField().color;
  }

  // Finds the logo and (if present) inspiration-photo upload fields by
  // reading the real question label via ClockFieldMatcher, instead of a
  // FIELD_MAPS id — the same move findHandColorField already made for hand
  // colour. A file upload's id is generated per listing just like every
  // other field's, so a hardcoded id silently drops the customer's logo on
  // any listing it wasn't written for; this is the one field type
  // collectUnmappedAnswers's catch-all cannot rescue, because there is no
  // way to carry an image through as a line of text.
  //
  // One upload question on the page is overwhelmingly the common case (both
  // real listings captured so far have exactly one, used as the logo slot
  // even where it is really a customer's photo) and is treated as the logo
  // with no further guessing needed. Two or more are disambiguated by label
  // wording; anything that still can't be told apart is left unmapped and
  // reported via console.warn rather than silently guessed, matching the
  // project's standing rule that no match beats a confidently wrong one.
  function findFileUploadFields() {
    var lib = window.ClockFieldMatcher;
    if (!lib) return { logo: '', inspiration: '' };
    var uploads = lib.describeQuestions(document).filter(function (q) { return q.type === 'file_upload'; });
    if (uploads.length === 0) return { logo: '', inspiration: '' };
    if (uploads.length === 1) return { logo: uploads[0].name, inspiration: '' };

    var inspirationKeywords = ['inspiration', 'reference', 'example'];
    var inspirationMatches = uploads.filter(function (q) {
      var text = lib.normalize(q.label);
      return inspirationKeywords.some(function (k) { return text.indexOf(k) !== -1; });
    });
    var logoMatches = uploads.filter(function (q) { return inspirationMatches.indexOf(q) === -1; });

    if (inspirationMatches.length === 1 && logoMatches.length === 1) {
      return { logo: logoMatches[0].name, inspiration: inspirationMatches[0].name };
    }

    console.warn(
      '[clock-designer] SETUP PROBLEM: ' + uploads.length + ' file upload questions were found ' +
      'and could not be confidently told apart by label, so only the first is being used (as the ' +
      'logo) and the rest are being ignored: ' + uploads.map(function (q) { return q.name + '=' + JSON.stringify(q.label); }).join(', ') + '. ' +
      'Tell Claude this product handle and this message so the right field can be mapped explicitly.'
    );
    return { logo: uploads[0].name, inspiration: '' };
  }

  // Any product-page question this code does not yet know the meaning of,
  // formatted as "<label>: <answer>" lines for the backend to pass along to
  // the AI as extra context (see models.py's extra_answers). Before this
  // existed, a question added after FIELD_MAPS was last updated — or any
  // question on a brand-new duplicated listing — had its answer
  // discarded entirely: the code did not recognize the field, so nothing
  // ever read it or sent it anywhere.
  //
  // File uploads are skipped: there is no sensible way to pass an uploaded
  // image through as a line of text, and a genuinely new upload field needs
  // real support (a mapped id), not this fallback. Hand color is excluded
  // too — findHandColorField already found it by value, so reporting it
  // again here would be redundant.
  function collectUnmappedAnswers(optis) {
    var lib = window.ClockFieldMatcher;
    if (!lib) return '';
    var excluded = mappedFieldIds();
    var handColorField = findHandColorField();
    if (handColorField.name) excluded[handColorField.name] = true;

    var lines = [];
    var questions = lib.describeQuestions(document);
    for (var i = 0; i < questions.length; i++) {
      var q = questions[i];
      if (excluded[q.name] || q.type === 'file_upload' || !q.label) continue;
      var value = q.type === 'dropdown'
        ? getDropdownVisibleText(q.name.slice('po_dropdown'.length))
        : (optis[q.name] || '');
      if (!value) continue;
      lines.push(q.label + ': ' + value);
    }
    return lines.join('\n');
  }

  function mapOptisToPayload(optis) {
    var fields = fieldsForThisListing();
    var uploadFields = findFileUploadFields();
    return {
      clock_style: fieldValue(optis, fields.clock_style),
      background_description: fieldValue(optis, fields.background_description),
      logo_url: optis[uploadFields.logo] || '',
      logo_position: fieldValue(optis, fields.logo_position) || 'Let AI decide',
      number_style: optis[fields.number_style] || '',
      additional_text: optis[fields.additional_text] || '',
      inspiration_url: optis[uploadFields.inspiration] || '',
      extra_notes: optis[fields.extra_notes] || '',
      art_style: fieldValue(optis, fields.art_style),
      upload_kind: uploadKind(),
      hand_color: getHandColor(),
      extra_answers: collectUnmappedAnswers(optis),
    };
  }

  // A generation runs ~34s at the median and past 115s one time in ten, and
  // the slowest real request took 300s — logged server-side as a 499,
  // "client has closed the request before the server could send a response".
  // Nothing was wrong with the connection: the design was still being drawn
  // and the browser stopped waiting, and the customer was told to check
  // their wifi.
  //
  // So no request is held open for the work any more. /generate/start
  // returns an id in milliseconds and the result is collected by polling,
  // which leaves nothing for a browser, a proxy or a phone changing network
  // to time out. Each poll is its own short request; one that fails is
  // retried on the next tick rather than failing the design.
  // Overridable on the root element so tests do not have to wait real
  // seconds per poll, and so the cadence can be tuned from the theme
  // without a code change.
  const POLL_INTERVAL_MS = Number(container.dataset.pollMs) || 2000;
  const POLL_GIVE_UP_MS = 600000;   // 10 minutes; far beyond any real run
  const POLL_TOLERATED_ERRORS = 5;  // consecutive, before giving up

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  async function callGenerate(payload) {
    // One silent restart if the job disappears underneath us. A deploy or a
    // restart drops in-flight jobs, and the customer sees a dead end asking
    // them to press Regenerate — for a design that was going fine, with
    // every answer still on the page. Restarting is what they would do by
    // hand, so do it for them; capped at one so a genuinely broken service
    // cannot spin.
    for (var attempt = 0; attempt < 2; attempt++) {
      try {
        return await runGenerationJob(payload);
      } catch (err) {
        if (err && err.code === 'JOB_VANISHED' && attempt === 0) {
          console.warn('[clock-designer] job vanished (service restarted?) — starting again');
          continue;
        }
        throw err;
      }
    }
  }

  async function runGenerationJob(payload) {
    payload.logo_base64 = clockLogoBase64;
    payload.extra_photos_base64 = clockExtraPhotos;
    payload.logo_mime_type = clockLogoMimeType;

    const startRes = await _origFetch.call(window, apiBase + '/generate/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!startRes.ok) {
      throw new Error('Could not reach the clock designer. Please try again in a moment.');
    }
    const { job_id: jobId } = await startRes.json();

    const deadline = Date.now() + POLL_GIVE_UP_MS;
    let consecutiveErrors = 0;
    while (Date.now() < deadline) {
      await sleep(POLL_INTERVAL_MS);
      let res;
      try {
        res = await _origFetch.call(window, apiBase + '/generate/status/' + jobId);
      } catch (err) {
        // A dropped poll is not a failed design. The work carries on
        // server-side, so try again on the next tick.
        if (++consecutiveErrors > POLL_TOLERATED_ERRORS) {
          throw new Error('Could not reach the clock designer. Please check your connection and try again.');
        }
        continue;
      }
      consecutiveErrors = 0;

      let body;
      try {
        body = await res.json();
      } catch (err) {
        if (++consecutiveErrors > POLL_TOLERATED_ERRORS) {
          throw new Error('Could not reach the clock designer. Please try again in a moment.');
        }
        continue;
      }

      if (body.status === 'done') return body.result;
      if (body.status === 'unknown') {
        // The job no longer exists. Jobs are held in the service's memory,
        // so a deploy or a restart takes any generation that was in flight
        // with it. Nothing is wrong with the customer's answers, which are
        // still sitting on the page — so this is recoverable rather than a
        // dead end, and callGenerate starts it again.
        var gone = new Error(body.error || 'That design is no longer available.');
        gone.code = 'JOB_VANISHED';
        throw gone;
      }
      if (body.status === 'error') {
        throw new Error(body.error || 'Generation failed');
      }
      // pending — keep waiting.
    }
    throw new Error(
      'The design is taking longer than usual and the page stopped waiting. ' +
      'Your answers are still here — press Regenerate to try again.'
    );
  }

  btn.addEventListener('click', async function () {
    // Re-read the upload before anything else, so the logo that is sent is
    // the file sitting in the field now rather than whatever a change event
    // happened to catch earlier.
    await readLogoNow();
    const optis = getOptisValues();
    const payload = mapOptisToPayload(optis);
    console.log('[clock-designer] productHandle:', productHandle, '| raw po_ fields:', optis, '| mapped payload:', payload);
    window._clockLogoUrl = payload.logo_url;
    window._clockLogoPosition = payload.logo_position;
    window._clockHandColor = payload.hand_color;
    window._clockLastPayload = payload;
    showLoading();
    try {
      const data = await callGenerate(payload);
      console.log('[clock-designer] prompt_used:', data.prompt_used);
      showResult(data.image_base64, data.production_image_url, data.raw_image_base64, data.logo_production_url, ringGeometryFromResponse(data), data.preview_image_url);
    } catch (err) {
      const msg = err.message && err.message.toLowerCase().includes('fetch')
        ? 'Could not reach the clock designer. Please check your connection and try again.'
        : err.message;
      showError(msg);
    }
  });

  /** Order the print-resolution file and put its URL on the order.
   *
   * Previews are generated at 1024 because most designs are never ordered,
   * and paying print resolution on every roll of Regenerate is money spent
   * on clocks nobody buys. Add to Cart is the one moment it buys something:
   * on a photo clock the difference is tyre lettering, wheel spokes and
   * chrome edges, which a resample can only smear — measured at 10.3/255
   * mean pixel error against a native render, where a flat graphic face
   * loses 1.5.
   *
   * The URL comes back immediately and the file lands under it a minute or
   * so later, so nobody waits at the button. If this call fails the
   * preview-resolution file is already on the order: that costs detail, not
   * the sale, so the cart is never blocked on it.
   */
  async function requestPrintResolution() {
    var base64 = window._clockRawImageBase64;
    if (!base64) return;
    try {
      var res = await _origFetch.call(window, apiBase + '/upscale/start', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_base64: base64 }),
      });
      if (!res.ok) return;
      var data = await res.json();
      if (data.production_image_url) {
        // Replaces the preview-resolution print file on every property and
        // hidden input the cart is about to carry.
        saveProductionUrl(data.production_image_url, clockPreviewUrl);
      }
    } catch (err) {
      console.warn('[clock-designer] print-resolution render could not be started', err);
    }
  }

  if (inlineAtc) {
    inlineAtc.addEventListener('click', async function () {
      await requestPrintResolution();
      if (addToCart) {
        addToCart.click();
      } else {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (form) form.submit();
      }
    });
  }

  if (retryBtn) {
    retryBtn.addEventListener('click', function () {
      btn.click();
    });
  }
})();
